import React from 'react';
import Section from '@atoms/Section/Section';
import Text from '@atoms/Text/Text';
import Title from '@atoms/Title/Title';
import TitleGroup from '@atoms/TitleGroup/TitleGroup';
import { Grid } from '@material-ui/core';
import './StepByStep.scss';
import CommonActionButton from './CommonActionButton';

const StepByStep = ({ list, ctaUrl, ctaLabel, title, subtitle }) => {
    return (
        <Section spacing="m" container="large" className="StepByStep">
            <Section spacingBottom="s">
                <TitleGroup
                    align="desktopCenter"
                    title={title}
                    subtitle={subtitle}
                />
            </Section>
            <Grid container spacing={4}>
                {list.map((item) => (
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={4}
                        lg={4}
                        className="StepByStep--item"
                    >
                        <Title className="StepByStep--icon">{item.icon}</Title>
                        <div className="StepByStep--text">
                            <Title size="ml" noMargin>
                                {item.title}
                            </Title>
                            <Text size="s">{item.subtitle}</Text>
                        </div>
                    </Grid>
                ))}
            </Grid>
            <Section spacingTop="xs">
                <CommonActionButton cta={{ ctaUrl, ctaLabel }} />
            </Section>
        </Section>
    );
};

export default StepByStep;
